import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TableConfigService {
  public bodyObject: any = {
    title: 'Gestion des accords',
    columns: [
      { field: 'libelle', header: 'Libellé', isText: true },
      { field: 'echeances', header: 'Echéances', isActions: true },
      { field: 'nb_parcelle', header: '#Parcelles', isText: true },
      { field: 'statut', header: 'Statut', isBadge: true },
      { field: 'created_at', header: 'Crée le', isText: true },
      { field: 'updated_at', header: 'Modifié le', isText: true },
    ]
  };
}
